import { createFileRoute } from '@tanstack/react-router';
import { PageShell, Section } from '~/components/layout';
import { CtaBanner, FaqAccordion } from '~/components/sections';
import { ButtonLink } from '~/components/ui';
import { getAppCta } from '~/content/navigation';
// Imported directly (not via the sections barrel) to avoid touching a shared
// file another agent may be editing.
import { ZakatCalculator } from '~/components/sections/ZakatCalculator';
import { pageHeadMeta } from '~/lib/seo';
import zakatStylesHref from '~/styles/zakat.css?url';

export const Route = createFileRoute('/zakat-calculator')({
  head: () =>
    pageHeadMeta({
      title: 'Calculate Your Zakat Today | Cash, Gold & Investments',
      description:
        "Calculate your Zakat with nsave's online calculator. Include cash, bank balances, gold, silver, and investments to see how much to pay today.",
      path: '/zakat-calculator',
      stylesheets: [zakatStylesHref],
    }),
  component: ZakatCalculatorPage,
});

export function ZakatCalculatorPage() {
  return (
    <PageShell>
      {/* Full-width grey band behind the whole hero + calculator, matching the
          send-money-home currency-calculator band (bg-grey-50). */}
      <Section className="bg-grey-50 pt-16 pb-16 md:pt-24 md:pb-24">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <h1 className="text-[40px] leading-[1.1] font-semibold tracking-[-0.03em] whitespace-pre-line text-balance md:text-title-m">
            {'Calculate your\nZakat with nsave'}
          </h1>
          <ButtonLink href={getAppCta.href} size="md" className="mt-9 md:mt-14">
            {getAppCta.label}
          </ButtonLink>
        </div>

        {/* 60px gap on mobile / 80px on desktop between the headline block and the calculator. */}
        <div className="zakat-calc-in mt-[60px] md:mt-20">
          <ZakatCalculator />
        </div>
      </Section>

      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
